(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('@mui/material/CssBaseline')) :
	typeof define === 'function' && define.amd ? define(['@mui/material/CssBaseline'], factory) :
	(global = typeof globalThis !== 'undefined' ? globalThis : global || self, global['@freska-fi/ui-css-baseline'] = factory(global.CssBaseline));
}(this, (function (CssBaseline) { 'use strict';

	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

	var CssBaseline__default = /*#__PURE__*/_interopDefaultLegacy(CssBaseline);



	return CssBaseline__default['default'];

})));
